/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import { IoArrowBackCircle, IoSettingsOutline } from "react-icons/io5";
import { DateRangePicker, Popover, SelectPicker, Whisper } from "rsuite";
import useAuth from "../hooks/useAuth";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { CiLogin } from "react-icons/ci";
import { HiOutlineMenu } from "react-icons/hi";

const Header = ({
  pageName,
  backBtn,
  selectedDate,
  setSelectedDate,
  isCategoryFilter,
  categoryData,
  selectedEquipCategories,
  setSelectedEquipCategories,
  isDateRange = false,
}) => {
  const navigation = useNavigate();
  const location = useLocation();
  const from = location.pathname || "/";
  const { setAuth, auth } = useAuth();
  const { setMenuOpen, isMobile } = useOutletContext();
  const whisperRef = useRef();

  const handleLogout = () => {
    whisperRef.current.close();
    sessionStorage.removeItem("loginUser");
    setAuth({});
    navigation("/", { replace: true });
  };

  const allowedDateRange = ["HO Dashboard", "Operational Dashboard"];

  return (
    <div className="w-100 d-flex flex-row justify-content-between align-items-center py-10">
      <div className="header-container d-flex flex-row align-items-center">
        {isMobile && (
          <HiOutlineMenu
            className="cursor fs-2 mr-10"
            onClick={() => setMenuOpen(true)}
          />
        )}
        <span className="fs-15">{pageName}</span>
      </div>

      <div className="d-flex flex-row align-items-center gap10">
        {isCategoryFilter && (
          <div className="filter-item">
            <SelectPicker
              data={categoryData}
              searchable={false}
              className="w-100"
              placeholder="Filter by Category"
              value={selectedEquipCategories}
              onChange={(value) => {
                if (value) {
                  setSelectedEquipCategories(value);
                } else {
                  setSelectedEquipCategories("");
                }
              }}
            />
          </div>
        )}
        {isDateRange && (
          <DateRangePicker
            size="md"
            placeholder="Select Date Range"
            block
            showOneCalendar
            value={(() => {
              const val =
                selectedDate?.length > 0
                  ? [new Date(selectedDate[0]), new Date(selectedDate[1])]
                  : null;
              return val;
            })()}
            shouldDisableDate={(date) => {
              const now = new Date();

              // Set today to 00:00:00
              const today = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
              );

              return date >= today;
            }}
            ranges={[]}
            onChange={(value) => {
              if (value?.length > 0) {
                // let startIosStringFormat = value[0]?.toISOString();
                // let endIosStringFormat = value[1]?.toISOString();
                const startDate = new Date(value[0]);
                startDate.setHours(0, 0, 0, 0);

                const endDate = new Date(value[1]);
                endDate.setHours(23, 59, 59, 999);

                const startIosStringFormat = startDate.toISOString();
                const endIosStringFormat = endDate.toISOString();
                setSelectedDate([startIosStringFormat, endIosStringFormat]);
              } else {
                setSelectedDate([]);
              }
            }}
          />
        )}
        {backBtn && (
          <div
            className="cursor"
            onClick={() => {
              navigation(-1);
            }}
          >
            <IoArrowBackCircle size={25} color="var(--blueColor)" />
          </div>
        )}
        <span className="cursor">
          <Whisper
            trigger="click"
            placement="auto"
            ref={whisperRef}
            speaker={
              <Popover>
                <div
                  className="d-flex cursor align-items-center"
                  style={{
                    gap: 10,
                  }}
                  onClick={handleLogout}
                >
                  <CiLogin size={18} />
                  <span>Logout</span>
                </div>
              </Popover>
            }
          >
            <div style={{ position: "relative" }}>
              <IoSettingsOutline size={22} />
            </div>
          </Whisper>
        </span>
      </div>
    </div>
  );
};

export default React.memo(Header);
